import { dispatcher, platform, soundService, textStyle } from "@aceroll/core";
import { clientData } from "@aceroll/core/core/ClientData";
import { serverData, ServerData } from "@aceroll/core/core/server/ServerData";
import "@aceroll/core/core/slots/ClientData";
import FromLaunchToReady from "@aceroll/core/core/stateMachine/FromLaunchToReady";
import { stateMachine } from "@aceroll/core/core/stateMachine/StateMachine";
import * as controllers from './controllers';
import * as layouts from './layouts';
import gameLoadedData from './platform/gameLoadedData.json';
import "./StateMachine";
import textStyles from './text-styles/textStyles.json';
import translationsTextStyles from './text-styles/translationsTextStyles.json';

const preloadIndicator = document.createElement('div');
preloadIndicator.id = 'PreloadIndicator';
document.body.appendChild(preloadIndicator);

// --------- debug --------- //
import { logger } from "@aceroll/core/core/debug/logger";
import { connection } from "@aceroll/core/core/server/Connection";

dispatcher.init({
    view: document.getElementById('webgl'),
    width: window.innerWidth,
    height: window.innerHeight,
    backgroundColor: 0x000000,
    antialias: false,
    legacy: false,
    powerPreference: "high-performance"
});

clientData.init();
stateMachine.init();

if (process?.env?.DEBUG === 'true') {
    window.clientData = clientData;
    window.dispatcher = dispatcher;
    window.platform = platform;
    window.serverData = serverData;
    window.ServerData = ServerData;
    window.stateMachine = stateMachine;
    window.logger = logger;
    window.connection = connection;
    window.app = dispatcher.app;
    window.soundService = soundService;
}



// Platform setup
platform.setGameLoadedData(gameLoadedData);

FromLaunchToReady.addAll();

/* ADD CONTROLLERS */
Object.keys(controllers).forEach((name) => {
    stateMachine.addStateController(new controllers[name]());
});

/* ADD TRANSITIONS */
stateMachine.addTransition({ from: "idle", to: "check.balance", action: "spin" });
stateMachine.addTransition({ from: "check.balance", to: "spin.start", fail: "idle" });
stateMachine.addTransition({ from: "spin.start", to: "round.start", guard: stateMachine.checkTransition("spin.start", "round.start") });
stateMachine.addTransition({ from: "spin.start", to: "round.fail", guard: stateMachine.checkTransition("spin.start", "round.fail") });
stateMachine.addTransition({ from: "round.fail", to: "idle" });
stateMachine.addTransition({ from: "round.start", to: "spin.stop" });
stateMachine.addTransition({ from: "spin.stop", to: "result" });
stateMachine.addTransition({ from: "result", to: "round.completed", guard: stateMachine.checkTransition("result", "round.completed") });
stateMachine.addTransition({ from: "result", to: "respin", guard: stateMachine.checkTransition("result", "respin") });
stateMachine.addTransition({ from: "respin", to: "spin.stop", guard: stateMachine.checkTransition("respin", "spin.stop") });
stateMachine.addTransition({ from: "respin", to: "feature.spin.stop", guard: stateMachine.checkTransition("respin", "feature.spin.stop") });
stateMachine.addTransition({ from: "result", to: "feature.enter", guard: stateMachine.checkTransition("result", "feature.enter") });
stateMachine.addTransition({ from: "result", to: "max.win", guard: stateMachine.checkTransition("result", "max.win") });
stateMachine.addTransition({ from: "max.win", to: "round.completed", guard: stateMachine.checkTransition("max.win", "round.completed") });
stateMachine.addTransition({ from: "max.win", to: "feature.round.completed", guard: stateMachine.checkTransition("max.win", "feature.round.completed") });
stateMachine.addTransition({ from: "feature.enter", to: "feature.spin.start" });
stateMachine.addTransition({ from: "feature.spin.start", to: "feature.spin.stop" });
stateMachine.addTransition({ from: "feature.spin.stop", to: "feature.spin.result" });
stateMachine.addTransition({ from: "feature.spin.result", to: "respin", guard: stateMachine.checkTransition("feature.spin.result", "respin") });
stateMachine.addTransition({ from: "feature.spin.result", to: "max.win", guard: stateMachine.checkTransition("feature.spin.result", "max.win") });
stateMachine.addTransition({ from: "feature.spin.result", to: "feature.round.completed", guard: stateMachine.checkTransition("feature.spin.result", "feature.round.completed") });
// stateMachine.addTransition({ from: "add", to: "multiply" });
// stateMachine.addTransition({ from: "multiply", to: "feature.round.completed" });
stateMachine.addTransition({ from: "feature.round.completed", to: "feature.spin.start", guard: stateMachine.checkTransition("feature.round.completed", "feature.spin.start") });
stateMachine.addTransition({ from: "feature.round.completed", to: "feature.exit", guard: stateMachine.checkTransition("feature.round.completed", "feature.exit") });
stateMachine.addTransition({ from: "feature.round.completed", to: "max.win", guard: stateMachine.checkTransition("feature.round.completed", "max.win") });
stateMachine.addTransition({ from: "feature.exit", to: "round.completed" });
stateMachine.addTransition({ from: "round.completed", to: "idle" });

stateMachine.initControllers();
stateMachine.launch("launch");

/* ADD LAYOUTS */
Object.keys(layouts).forEach((name) => {
    dispatcher.app.addLayout(name, new layouts[name]());
});


/* Setup Text styles */
textStyle.setStyles(textStyles);
textStyle.setTranslations(translationsTextStyles);
